const initHeroSlideshow=()=>{
 window.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-swiper]').forEach(s=>{
   const a=Boolean(s.getAttribute('data-swiper-autoplay'));
   const d=Number(s.getAttribute('data-autoplay-speed'))*1000;
   new Swiper(s,{
    loop:true,
    autoplay:a?{delay:d}:false,
    navigation:{
     nextEl:s.querySelector('.hero-slideshow__swiper-button--next'),
     prevEl:s.querySelector('.hero-slideshow__swiper-button--prev')
    },
    pagination:{
     el:s.querySelector('.swiper-pagination')
    }
   });
  });
 });
};
initHeroSlideshow();